module.exports = __webpack_public_path__ + "resources/img/img_ai_easymaker_jp.3eb9bb25d35c5560158d4cd2b4269d27.png";